import { z } from 'zod';
import { NullableJsonValue } from "../inputTypeSchemas/NullableJsonValue"

/////////////////////////////////////////
// DOCUMENTS SCHEMA
/////////////////////////////////////////

export const DocumentsSchema = z.object({
  id: z.bigint(),
  city_id: z.number().int().nullable(),
  title: z.string(),
  data: NullableJsonValue.optional(),
  status: z.string().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  record_type: z.string().nullable(),
  record_id: z.bigint().nullable(),
  documentable_type: z.string().nullable(),
  documentable_id: z.bigint().nullable(),
  documents_type_id: z.bigint().nullable(),
  issued_at: z.coerce.date().nullable(),
})

export type Documents = z.infer<typeof DocumentsSchema>

export default DocumentsSchema;
